// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ModifyTrailingStopOrder } from '../order-modify/ModifyTrailingStopOrder';
import { OrderTypeBase } from './OrderTypeBase';
import { OrderType } from '@shared/utils/Trading/OrderType';
import { RulesSet } from '@shared/utils/Rules/RulesSet';
import { TrailingStopOrderEdit } from '../order-edit/TrailingStopOrderEdit';
export class TrailingStopOrderType extends OrderTypeBase {
    constructor() {
        super(TrailingStopOrderEdit, ModifyTrailingStopOrder);
    }
    id() {
        return OrderType.TrailingStop;
    }
    localizationKey() {
        return 'Tr. stop';
    }
    IsSupported(params) {
        const allowedByRule = params.checkRuleForTrailingStopOrder
            ? this.checkRuleForAccount(params.account, RulesSet.FUNCTION_TRAILING_STOP, params.instrument)
            : true;
        return allowedByRule && super.IsSupported(params);
    }
}
